import { twMerge } from 'tailwind-merge';
import { type ClassValue, clsx } from 'clsx';

export const isClient = typeof window === 'object';

export function omitEmptyValues<Type>(obj: Record<string, unknown>): Type {
    return Object.keys(obj).reduce((acc, key) => {
        const entry = obj[key];
        if (entry !== null && typeof entry !== 'undefined' && entry !== '') {
            acc[key] = obj[key];
        }
        return acc;
    }, {} as any);
}

/** @deprecated use `nuqs` instead * */
export function queryParamsToString(queryParams: object): string {
    return Object.entries(queryParams).reduce((acc, [key, value]) => {
        if (!value) {
            return acc;
        }
        return `${acc}&${key}=${value}`;
    }, '');
}

export const where = (key: string) => (value: any) => (obj: any) => obj[key] === value;
export const whereId = where('id');
export const whereName = where('name');

export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}
